/**
 * H2 `toTop()` (04-05-GuidedExposures, 03-RenewalFlow): every Continue lands the customer at the
 * top of the new page. Sets the document's scroll position directly, which every browser honours
 * and jsdom accepts without its "not implemented" `window.scrollTo` warning.
 */
export function scrollToTop(): void {
  if (typeof document === "undefined") {
    return;
  }
  const root = document.scrollingElement ?? document.documentElement;
  root.scrollTop = 0;
  root.scrollLeft = 0;
}
